import { CONFIG_VARS } from "../../constants/urlConstants/configuration";

const roleMap = CONFIG_VARS.roleMappings[1];

export const getRoleName = (roleId) => roleMap[roleId] || "Unknown Role";
